module.exports = __webpack_public_path__ + "570eb83859dc23dd0eec423a49e147fe.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons/iconfont/MaterialIcons-Regular.woff2
// module id = 256
// module chunks = 0 2